import React from 'react'
import { Modal } from '@therms/atalaya'
import { LocationBoloForm, useLocationContext } from '@therms/react-modules'

interface BoloFormModalProps {
  boloId?: string
  closeHandler: () => void
  onComplete: () => void
}

function BoloFormModal({
  boloId,
  closeHandler,
  onComplete,
}: BoloFormModalProps) {
  const { locationId } = useLocationContext(true)

  return (
    <Modal
      header={boloId ? 'Edit Bolo' : 'Create Bolo'}
      closeHandler={closeHandler}
      width="md"
    >
      <LocationBoloForm
        boloId={boloId}
        locationId={locationId}
        onCancel={closeHandler}
        onComplete={() => {
          closeHandler()
          onComplete()
        }}
      />
    </Modal>
  )
}

export { BoloFormModal }
